export const SESSION_ID_COOKIE_NAME = "session-id";
export const CLIENT_ID_COOKIE_NAME = "client-id";
export const LANGUAGE_COOKIE_NAME = "language";
export const COUNTRY_COOKIE_NAME = "country";
export const LEGACY_CURRENCY_COOKIE_NAME = "currency";
export const CURRENCY_COOKIE_NAME = "mb-currency";
export const TRACK_ID_COOKIE_NAME = "track-id";
